import { render, staticRenderFns } from "./MyModal.vue?vue&type=template&id=ceb7ab3a&scoped=true&"
import script from "./MyModal.vue?vue&type=script&lang=js&"
export * from "./MyModal.vue?vue&type=script&lang=js&"
import style0 from "./MyModal.vue?vue&type=style&index=0&id=ceb7ab3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb7ab3a",
  null
  
)

export default component.exports